import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={styles["icon-svg"] || "icon-svg"} width="48" height="48" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19.4 32.6l9.1-9.1-9.1-9.1" stroke="currentColor" fill="none" /></svg>;